export enum AnalyticsNamespace {
	SchedulePage = 'SchedulePage',
	AdjacentAppointments = 'AdjacentAppointments',

	PatientLookupHeader = 'PatientLookupHeader',
	PatientLookupPage = 'PatientLookupPage',

	Document = 'Document',
	RecommendedDx = 'RecommendedDx',
	NoteWizard = 'NoteWizard',
	AIAssessmentEvent = 'AIAssessmentEvent',

	AdminUsersTable = 'AdminUsersTable',
	AdminUserModal = 'AdminUserModal',

	RafScore = 'RafScore',

	FileManagerPage = 'FileManagerPage',
}

export const ANALYTICS_TEMPLATES = {
	getClickEventName: (namespace: AnalyticsNamespace) => `${namespace} Click`,
	getLoadEventName: (namespace: AnalyticsNamespace) => `${namespace} Load`,
} as const satisfies Record<
	`get${string}EventName`,
	(namespace: AnalyticsNamespace) => `${typeof namespace} ${string}`
>;
